import { ProxyApplicationListItem } from "../models";

type EventName = 'create_proxy_application' | 'change_plan' | 'delete_proxy_application' |
  'signup' | 'login' | 'redirect_to_stripe' | 'link_vercel' | 'copy_curl' | 'add_user' | 'delete_user';

export function trackEvent(eventName: EventName, eventParams: Record<string, any> = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  } else {
    console.log('gtag not found');
  }
}

export const trackConversionEvent = (eventName: EventName, proxyApplication: ProxyApplicationListItem) =>
  trackEvent(eventName, {
    proxy_application_id: proxyApplication._id,
    proxy_application_name: proxyApplication.name,
    plane_name: proxyApplication.plan.name,
    value: proxyApplication.plan.priceAmount / 100, // Convert cents to dollars
    currency: 'USD',
    items: [{
      item_name: proxyApplication.plan.name,
      quantity: 1,
      item_id: proxyApplication.plan._id,
      price: proxyApplication.plan.priceAmount / 100
    }]
  });

export const setUserId = (userId: string) => {
  window.gtag('set', { user_id: userId });
}

export default trackEvent;
